import React from 'react';
import { useAppColorTheme } from '../../contexts/AppOptionsProvider';

export default function MainLayout({ children }){
    
    const colorTheme = useAppColorTheme()

    return <main className={"theme-" + colorTheme}>{ children }</main>
}